// src/components/homeComponents/VelocityMarquee.jsx
import React, { useRef } from "react";
import styled from "styled-components";
import {
  motion,
  useScroll,
  useVelocity,
  useSpring,
  useTransform,
  useMotionValue,
  useAnimationFrame,
  wrap,
} from "framer-motion";

const ROW_ONE = [
  "Orhidea Perfume",
  "Pretty Needs",
  "RRUSH",
  "OrgaLife",
  "Coolest Parfume",
  "Jara Boutique",
];
const ROW_TWO = [
  "Travelo",
  "Siara Styler",
  "Argo Drinks",
  "NudR",
  "Elaia Aesthetic",
  "Head Case Factory",
];

function MarqueeRow({ items, baseVelocity }) {
  const baseX = useMotionValue(0);
  const { scrollY } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400,
  });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false,
  });

  const x = useTransform(baseX, (v) => `${wrap(-50, 0, v)}%`);
  const directionFactor = useRef(1);

  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * baseVelocity * (delta / 1000);
    if (velocityFactor.get() < 0) directionFactor.current = -1;
    else if (velocityFactor.get() > 0) directionFactor.current = 1;
    moveBy += directionFactor.current * moveBy * velocityFactor.get();
    baseX.set(baseX.get() + moveBy);
  });

  const loop = [...items, ...items, ...items, ...items];

  return (
    <div className="row">
      <motion.div className="scroller" style={{ x }}>
        {loop.map((name, i) => (
          <span className="item" key={i}>
            {name}
            <i className="dot">✦</i>
          </span>
        ))}
      </motion.div>
    </div>
  );
}

const VelocityMarquee = () => {
  return (
    <Container>
      <div className="head">
        <span className="kicker">THE ROSTER</span>
        <h2>
          Brands that refuse <br /> to <em>blend in.</em>
        </h2>
      </div>
      <MarqueeRow items={ROW_ONE} baseVelocity={-2.5} />
      <MarqueeRow items={ROW_TWO} baseVelocity={2.5} />
    </Container>
  );
};

const Container = styled.section`
  background: #08040c;
  padding: 9em 0 7em;
  overflow: hidden;
  position: relative;

  .head {
    padding: 0 7%;
    margin-bottom: 1.8em;
    .kicker {
      font-family: "Montserrat";
      letter-spacing: 0.45em;
      font-size: 0.72rem;
      color: #836caf;
      font-weight: 500;
    }
    h2 {
      font-family: "Readex Pro", sans-serif;
      font-weight: 200;
      font-size: clamp(2rem, 5vw, 4.5rem);
      line-height: 0.95;
      margin-top: 0.3em;
      em {
        font-style: italic;
        color: #9281dd;
      }
    }
  }

  .row {
    display: flex;
    overflow: hidden;
    user-select: none;
    white-space: nowrap;
    flex-wrap: nowrap;
  }
  .scroller {
    display: flex;
    white-space: nowrap;
    flex-wrap: nowrap;
  }
  .item {
    display: inline-flex;
    align-items: center;
    font-family: "Readex Pro", sans-serif;
    font-weight: 200;
    font-size: clamp(2.4rem, 6vw, 5.5rem);
    color: #ffffff;
    padding: 0 0.4em;
    line-height: 1.25;
    .dot {
      color: #463d6e;
      font-style: normal;
      font-size: 0.4em;
      margin-left: 0.8em;
      transform: translateY(-0.3em);
    }
  }
  .row:nth-child(3) .item {
    color: transparent;
    -webkit-text-stroke: 1px #4a3f6e;
  }
`;

export default VelocityMarquee;
